import React, { useContext } from "react";
import { Link } from "react-router-dom";
import Masonry from "react-masonry-css";
import { Context } from "../../Context/ContextApi";

const Products = () => {
  const { homeProducts } = useContext(Context);
  const homeProductsData = homeProducts?.data?.products;

  const breakpointColumnsObj = {
    default: 4,
    1200: 3,
    768: 2,
    576: 1,
  };

  return (
    <>
      <div className="product-section py-5">
        <div className="container">
          <h1 className="text-center text-white mb-4">
            Purchase Now: Your Online Destination for Exquisite Paintings
          </h1>

          <Masonry
            breakpointCols={breakpointColumnsObj}
            className="my-masonry-grid"
            columnClassName="my-masonry-grid_column"
          >
            {homeProductsData?.map((item) => (
              <div key={item.id} className="masonry-item mt-4">
                <div className="card h-100 shadow-sm">
                  <img
                    src={`https://admin.tulikaarts.in/${item?.product_image}`}
                    alt={item.product_name}
                    className="card-img-top"
                  />
                  <div className="card-body">
                    <h5 className="card-title" style={{color:"black"}}>{item.product_name}</h5>
                    <div className="d-flex justify-content-between align-items-center">
                      <p className="mb-0" style={{color:"black"}}>
                        <strong>Size:</strong> {item.product_size}
                      </p>
                      <p className="mb-0 fw-bold text-black" style={{color:'#cc9051'}}>
                        &#8377;{parseInt(item.product_price)}
                      </p>
                      
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Masonry>

          <div className="view-all-button text-center mt-4">
            <Link to="/product">
              <button className="btn btn-outline-light">View All Paintings</button>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default Products;
